import { gql } from '@apollo/client';

/**
 * Query for getting API Portal orgs
 */
export const GET_API_PORTAL_ORGS_PAGED = gql`
  query ApiPortal {
    devhub {
      apiPortal {
        apiPortalOrgsPaged {
          totalCount
          orgs {
            name
            _normalizedName
          }
        }
      }
    }
  }
`;
